import React from 'react';
import workspaceQuery from '../../../graphql/queries/supplier/SupplierWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/supplier/SupplierListQuery.graphql';
import instanceQuery from '../../../graphql/queries/supplier/SupplierQuery.graphql';
import defaultQuery from '../../../graphql/queries/supplier/SupplierDefault.graphql';
import mutationQuery from '../../../graphql/mutations/supplier/SupplierMutation.graphql';
import aggregateQuery from '../../../graphql/queries/supplier/SupplierAggregateQuery.graphql';
import fragment from '../../../graphql/fragments/supplier/SupplierFragment.graphql';
import basicQuery from '../../../graphql/queries/supplier/SupplierQueryBasic.graphql';

import mutationTempQuery from '../../mutations/supplier/SupplierTempMutation.graphql';
import { formActions } from '../../../actions/supplier/SupplierAction';
import { workspaceActionsForPermissions } from '../../../actions/supplier/SupplierWorkspaceAction';
import { supplierDocument } from '../../../utils/mailMergeFields';
import { ISupplier } from '../../schema/p4types';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';

//TODO - Can we replace uses of this with 'NominalOptionRenderer'? Does it harm any use to include the name? (See also - BasicNominalOptionRenderer)
//(Kept separate for the moment to avoid unnecessary changes to user experience)
export const BasicSupplierOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: ISupplier }) => {
  return <span>{option.reference}</span>;
};

const SupplierOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: ISupplier }) => {
  if (!option) {
    return null;
  }

  return (
    <span>
      {option.reference} {option.name}
    </span>
  );
};

const Supplier: EntityType = {
  type: 'Supplier',
  title: 'Suppliers',
  formTitle: 'Supplier',
  formUrl: '/Suppliers/Supplier/Details/',
  workspaceUrl: '/Suppliers/Supplier/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  basic: basicQuery,
  update: mutationQuery,
  notificationKey: 'reference',
  temporarySave: mutationTempQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    optionRenderer: SupplierOptionRenderer,
    valueRenderer: SupplierOptionRenderer,
    filterOption: () => true, //Override Default
    remoteFilter: true,
    placeholder: 'Search suppliers',
    pageView: false,
    asButton: false,
    selectModal: 'SupplierWorkspace',
    sidebarForm: 'SupplierForm',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SUPPLIERS',
  actions: [...formActions, ...workspaceActionsForPermissions],
  mergeFields: supplierDocument,
};

export default Supplier;
